export default "__VITE_ASSET__DzrHyzDK__"